// Breadcrumbs Component
// LazySEM Frontend - Navigation breadcrumbs

import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Breadcrumbs.module.css';

interface Breadcrumb {
  label: string;
  path?: string;
}

interface BreadcrumbsProps {
  breadcrumbs: Breadcrumb[];
  className?: string;
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  breadcrumbs,
  className = '',
}) => {
  if (breadcrumbs.length <= 1) {
    return null;
  }

  return (
    <nav className={`${styles.breadcrumbs} ${className}`} aria-label="Breadcrumb">
      <ol className={styles.breadcrumbList}>
        {breadcrumbs.map((breadcrumb, index) => {
          const isLast = index === breadcrumbs.length - 1;
          
          return (
            <li key={index} className={styles.breadcrumbItem}>
              {isLast ? (
                <span className={styles.breadcrumbCurrent} aria-current="page">
                  {breadcrumb.label}
                </span>
              ) : breadcrumb.path ? (
                <Link to={breadcrumb.path} className={styles.breadcrumbLink}>
                  {breadcrumb.label}
                </Link>
              ) : (
                <span className={styles.breadcrumbText}>
                  {breadcrumb.label}
                </span>
              )}
              
              {!isLast && (
                <svg 
                  className={styles.breadcrumbSeparator} 
                  width="16" 
                  height="16" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2"
                  aria-hidden="true"
                >
                  <polyline points="9,18 15,12 9,6" />
                </svg>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs; 